interface PainPointItem {
  id?: string;
  icon?: string;
  title: string;
  description: string;
}

interface PainPointsGridProps {
  items: PainPointItem[];
}

/**
 * PainPointsGrid
 *
 * 2-column problem-statement cards used by `problem.painPoints` and
 * similar arrays. Visually distinct from `ScopeGrid` (red/orange accent)
 * to signal the "current pain" framing before the solution sections.
 */
export default function PainPointsGrid({ items }: PainPointsGridProps) {
  if (!Array.isArray(items) || items.length === 0) {
    throw new Error("PainPointsGrid: `items` array is empty or invalid.");
  }

  return (
    <div className="pain-points-grid">
      {items.map((item, idx) => (
        <article
          className="pain-point"
          key={item.id ?? `${item.title}-${idx}`}
        >
          <span className="pain-point-marker" aria-hidden>
            !
          </span>
          <div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        </article>
      ))}
    </div>
  );
}
